import { get } from "lodash";

export default {
  getRegistrationValue: state => (attribute, fallback = null) => get(state.profile, attribute, fallback),

  // filter out any error keys that have an empty array of messages
  getRegistrationErrors: state => (attribute = null) => {
    const errors = Object.keys(state.errors)
      .filter(key => state.errors[key].length)
      .reduce((acc, key) => ({ ...acc, [key]: state.errors[key] }), {});

    return attribute ? errors[attribute] : errors;
  },

  hasRegistrationError: (_, getters) => attribute => getters.getRegistrationErrors().hasOwnProperty(attribute),
};
